// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__T2-Bo","footer":"ModalError_footer__2CGUa"};